var link_preview_default = {
  "fontElementMap": "FrnXZ",
  "linkPreviewContainer": "nxlE4",
  "linkPreview": "I9BOs",
  "linkPreviewImage": "-WZoG",
  "linkPreviewPlaceholder": "_6PQA0",
  "linkPreviewInfo": "LPneG",
  "linkPreviewTitle": "s9fSi",
  "linkPreviewDescription": "-Lyki",
  "linkPreviewUrl": "jnGwM",
  "linkPreviewResponsiveImage": "_68xkH",
  "loadingContainer": "RV7sh",
  "errorIcon": "gmwQZ",
  "errorInfo": "HWF69",
  "errorContainer": "lIJ-I",
  "overlay": "_0-RYi",
  "thumbnailEnd": "Eq6n4",
  "thumbnailStart": "qAScg",
  "thumbnailTop": "H-phc"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
